import { Configuration } from '@swpsoftware/commons-api';

export function goToLogin() {
  const location = window.location.href;
  window.location.href = `${Configuration.getAccountsUrl()}login?continue=${encodeURIComponent(location)}`;
}
